import { render, staticRenderFns } from "./OmsCard.vue?vue&type=template&id=c825bf4c"
import script from "./OmsCard.vue?vue&type=script&lang=js"
export * from "./OmsCard.vue?vue&type=script&lang=js"
import style0 from "./OmsCard.vue?vue&type=style&index=0&id=c825bf4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports